<!-- 个人主页 -->
<template>
    <div
        v-visually="{
            serverId: 17078,
            area: 'home-info',
        }"
        class="home"
    >
        <div class="tabs">
            <div
                v-for="item in tabs"
                :key="item.key"
                class="tab-item"
                :class="{'active': curTab === item.key}"
                @click="tabChange(item)"
            >{{ item.name }}</div>
        </div>
        <!-- 移动端内容 -->
        <section v-show="curTab === 'h5'" class="h5-content">
            <div class="left">
                <img
                    src="https://lvlin-base.cdn.bcebos.com/fe-saas/page/personal-info/phone_case.png" class="phone-pic"
                >
            </div>
            <div class="right">
                <div class="title">移动端主页预览与查看</div>
                <!-- 二维码 -->
                <div class="qr-code">
                    <canvas ref="qrcode"></canvas>
                </div>
                <!-- 步骤提示 -->
                <div class="steps">
                    <p class="steps-title">预览步骤：</p>
                    <p class="step-item"><span>01.</span>打开手机百度APP</p>
                    <p class="step-item"><span>02.</span>扫描上方二维码</p>
                    <p class="step-item"><span>03.</span>预览/查看个人主页</p>
                </div>
            </div>
        </section>
        <!-- pc端内容 -->
        <section
            v-show="curTab === 'pc'"
            class="pc-content"
            :class="{'is-show-guide': !+vipInfo.vipStatus}"
        >
            <div class="config">
                <div class="label">PC主页版式设置：</div>
                <div class="radio-group">
                    <div
                        v-for="item in configRadios"
                        :key="item.value"
                        class="radio-item"
                        @click="configChange(item)"
                    >
                        <span class="radio-box" :class="{'selected': configValue === item.value}"></span>
                        {{ item.label }}
                        <span v-if="item.value === '1'" style="color: #ff5353;">(推荐)</span>
                    </div>
                </div>
            </div>
            <div
                :class="['preview', configValue === '1' ? 'is-yellow-bg' : '', !+vipInfo.vipStatus ? 'not-vip' : '']"
            >
                <div>
                    <div class="preview-title">预览与查看地址：</div>
                    <a
                        class="preview-url"
                        :href="lawyerHomeUrl"
                        target="_blank"
                        @click="sendClickLog('normal-preview')"
                    >{{ lawyerHomeUrl }}</a>
                    <div class="preview-tips">（配置完成后实时生效）</div>
                </div>
                <div class="iframe-box">
                    <iframe
                        id="preview-iframe"
                        :src="lawyerHomeUrl"
                        frameborder="0"
                        width="1440px"
                        height="100%"
                        @load="changePreviewStyle(configValue)"
                    ></iframe>
                </div>
            </div>
            <!-- 非会员时展示 -->
            <div v-if="!+vipInfo.vipStatus && configValue === '1'" class="fixed-btns">
                <authorize-btns/>
            </div>
        </section>
    </div>
</template>

<script>
import {mapState, mapActions} from 'vuex';
import QRCode from 'qrcode';
import authorizeBtns from '../components/authorize-btns.vue';
import {HOME_CASE_ARR} from '../config/index';

export default {
    props: {
        bannerConfig: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            curTab: 'h5',
            tabs: [
                {
                    name: '移动端主页',
                    key: 'h5'
                },
                {
                    name: 'PC端主页',
                    key: 'pc'
                }
            ],
            configRadios: [
                {value: '0', label: '使用简约版主页'},
                {value: '1', label: '使用商务版主页'}
            ],
            // 使用标准版还是会员版
            configValue: '',
            colorConfig: {},
            homeCaseArr: HOME_CASE_ARR
        };
    },
    computed: {
        ...mapState({
            vipInfo: state => state.lawStore.vipInfo || {},
            lawyerInfo: state => state.lawStore.userInfoNew.lawyer_info || {},
            userInfo: state => state.lawStore.userInfoNew || {}
        }),
        lawyerHomeUrl() {
            return `https://lvlin.baidu.com/pc/lawyer?rs_id=4941&qc_no=${this.lawyerInfo.register_id}`;
        }
    },
    mounted() {
        this.createQrCode();
        this.configValue = this.lawyerInfo?.appearance_config?.pc_home_type + '' || '0';
        this.colorConfig = this.lawyerInfo?.appearance_config?.color_config || {};
    },
    components: {
        'authorize-btns': authorizeBtns
    },
    methods: {
        ...mapActions({
            saveAppearanceConfig: 'lawStore/saveAppearanceConfig'
        }),
        tabChange(item) {
            if (item.key !== this.curTab) {
                this.curTab = item.key;
                this.sendClickLog(item.key === 'h5' ? 'h5-home-tab' : 'pc-home-tab');
            }
        },
        // 生成二维码
        createQrCode() {
            if (this.lawyerInfo.register_id) {
                let url = `https://lvlin.baidu.com/pages/experthome/index?qc_no=${this.lawyerInfo.register_id}`;
                QRCode.toCanvas(this.$refs.qrcode, url, {width: 200, height: 200, margin: 0}, error => {});
            }
        },

        /**
         * 标准版、会员版切换
         * @param {String} value 选中值
         */

        configChange({value}) {
            if (value === this.configValue) {
                return;
            }
            this.sendClickLog(value === '0' ? 'normal-radio' : 'vip-radio');
            // 非会员选择会员版，仅能预览，不提交
            if (!this.lawyerInfo.register_id && value === '1') {
                this.configValue = value;
                this.changePreviewStyle(value);
                return;
            }
            this.saveAppearanceConfig({
                pc_home_type: value,
                business_lawyer_id: this.userInfo?.lawyer_info?.business_lawyer_id
            }).then(res => {
                this.configValue = value;
                this.changePreviewStyle(value);
                this.$toast.success('修改成功');
            }).catch(res => {
                this.$toast.error(res && res.msg || '修改失败，请稍候再试~');
            });
        },

        // 向iframe子页面发送message，切换预览样式
        changePreviewStyle(value) {
            let iframe = document.getElementById('preview-iframe');
            iframe.contentWindow.postMessage({
                isLawyerHomePreview: true,
                type: +value + 1,
                back_ground: this.bannerConfig.back_ground || this.colorConfig.back_ground || 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/personal-info/bg1.png',
                color_value: this.bannerConfig.color_value || this.colorConfig.color_value || '#152d69'
            }, '*');
        },

        sendClickLog(area) {
            this.$wywLog.send({
                serverId: 17078,
                action: 'click',
                area
            });
        }
    }
};
</script>

<style lang='less' scoped>
@font-face {
    font-family: "baidunumber-Medium";
    src: url("../../../assets/fonts/baidunumber-Medium.ttf");
}

.home {
    height: 100%;
    overflow: auto;

    .tabs {
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgb(246, 247, 250);
        width: 356px;
        border-radius: 8px;
        height: 42px;
        margin: 24px auto 21px;

        .tab-item {
            width: 176px;
            font-family: PingFangSC-Semibold;
            font-size: 14px;
            line-height: 38px;
            font-weight: 600;
            color: #848691;
            text-align: center;
            cursor: pointer;
            height: 38px;

            &.active {
                background: #fff;
                color: #05f;
                border-radius: 6px;
            }
        }
    }

    .h5-content {
        display: flex;
        border: 1px solid rgba(233, 236, 243, 1);
        border-radius: 8px;
        justify-content: center;

        .phone-pic {
            width: 388px;
            height: 710px;
            border-radius: 35px;
        }

        .right {
            margin-left: 120px;
            margin-top: 65px;

            .title {
                margin-bottom: 18px;
                font-family: PingFangSC-Semibold;
                font-size: 24px;
                color: #1e1f24;
                line-height: 24px;
                font-weight: 600;
            }

            .qr-code {
                height: 340px;
                width: 330px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-left: -42px;
                margin-top: -35px;
                background: url("https://lvlin-base.cdn.bcebos.com/fe-saas/page/personal-info/bubble.png") no-repeat center center/ 100% 100%;

                canvas {
                    margin-top: -20px;
                }
            }

            .steps {
                padding: 42px 24px;
                border: 1px solid rgba(233, 236, 243, 1);
                border-radius: 12px;
                margin-top: -28px;
                width: 244px;

                .steps-title {
                    font-family: PingFangSC-Regular;
                    font-size: 16px;
                    color: #848691;
                    line-height: 16px;
                    font-weight: 400;
                    margin-bottom: 32px;
                }

                .step-item {
                    line-height: 20px;
                    height: 16px;
                    color: #1e1f24;
                    font-weight: 500;
                    display: flex;

                    &:not(:last-child) {
                        margin-bottom: 44px;
                    }

                    span {
                        font-family: baidunumber-Medium;
                        font-size: 20px;
                        color: #0255ff;
                        font-weight: 500;
                        margin-right: 10px;
                    }
                }
            }
        }
    }

    .pc-content {
        &.is-show-guide .preview-pic {
            padding-bottom: 50px;
        }

        .config {
            display: flex;
            align-items: center;
            margin-bottom: 22px;

            .label {
                font-family: PingFangSC-Semibold;
                font-size: 14px;
                color: #1e1f24;
                line-height: 14px;
                font-weight: 600;
                margin-right: 15px;
            }

            .radio-group {
                display: flex;

                .radio-item {
                    &:not(:first-child) {
                        margin-left: 32px;
                    }

                    .radio-box {
                        width: 16px;
                        height: 16px;
                        display: inline-block;
                        position: relative;
                        border: 1px solid #d3d9e6;
                        cursor: pointer;
                        box-sizing: border-box;
                        border-radius: 50%;
                        top: 3px;
                        right: 4px;

                        &.selected {
                            background-color: #05f;
                            border: none;

                            &::before {
                                width: 6px;
                                height: 6px;
                                content: "";
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                background-color: #fff;
                                border-radius: 50%;
                                transform: translate(-50%, -50%) scale(1);
                            }
                        }
                    }
                }
            }
        }

        .preview {
            border-radius: 6px;
            padding: 13px 0;
            height: 1000px;
            background: #f5f6f9;

            .preview-title {
                font-family: PingFangSC-Semibold;
                font-size: 14px;
                color: #1e1f24;
                line-height: 14px;
                font-weight: 600;
                padding: 0 18px;
                display: inline-block;
            }

            .preview-url {
                font-family: PingFangSC-Regular;
                color: #0051ff;
                font-weight: 400;
                display: inline-block;
                margin-bottom: 13px;
            }

            .preview-tips {
                display: inline-block;
                font-size: 14px;
                color: #696969;
                margin-left: 12px;
            }

            .iframe-box {
                height: 100%;
                width: 100%;
                overflow-y: auto;
                overflow-x: hidden;
                border: 2px solid #f5f6f9;

                iframe {
                    transform: scale(.75);
                    transform-origin: 0 0;
                }
            }

            .preview-sub-title {
                font-family: PingFangSC-Regular;
                font-size: 12px;
                color: #848691;
                line-height: 12px;
                font-weight: 400;
                padding: 13px 18px 19px;
                display: flex;

                .tips {
                    position: relative;
                    padding-left: 20px;

                    &:first-child {
                        margin-right: 30px;
                    }

                    &::before {
                        content: "";
                        height: 14px;
                        width: 14px;
                        display: inline-block;
                        position: absolute;
                        top: 0;
                        left: 0;
                        background: url(https://lvlin-base.cdn.bcebos.com/fe-saas/page/personal-info/vip-icon.png) no-repeat center center / 100%;
                    }
                }
            }

            .preview-pic {
                width: 100%;
                border-radius: 6px;
                border: 2px solid #f5f6f9;
                border-top: 1px solid rgba(244, 244, 244, 1);
            }
        }

        .fixed-btns {
            position: fixed;
            bottom: 53px;
            height: 34px;
            left: calc(50vw - 200px);

            /deep/.authorize-btns {
                width: 604px;
                margin: 0 auto;
            }
        }
    }
}
</style>
